module.exports = __webpack_public_path__ + "img/ic_train.e704dd6f.svg";